import { AuthServiceConfig, FacebookLoginProvider } from 'angularx-social-login';
import { environment } from '@env/environment';

export function getAuthServiceConfigs() {
  const config = new AuthServiceConfig([
    {
      id: FacebookLoginProvider.PROVIDER_ID,
      provider: new FacebookLoginProvider(environment.facebookAppId)
    }
  ]);

  return config;
}
